/**
 * Pilha de modais abertos
 *
 * Com modais empilhados (ex.: modal de opções do produto aberto em portal sobre o
 * "Novo pedido"), só o modal do topo deve responder ao Esc. Cada modal se registra
 * ao abrir e sai da pilha ao fechar.
 *
 * @author Equipe VendeAi
 * @since 1.4.0
 */

const stack: symbol[] = [];

/** Registra um modal aberto; devolve o id e a função que o remove da pilha */
export function pushModal(): { id: symbol; release: () => void } {
  const id = Symbol('modal');
  stack.push(id);
  return {
    id,
    release: () => {
      const index = stack.lastIndexOf(id);
      if (index >= 0) stack.splice(index, 1);
    },
  };
}

/** O modal é o do topo da pilha (o único que deve tratar Esc) */
export function isTopModal(id: symbol): boolean {
  return stack.length > 0 && stack[stack.length - 1] === id;
}
